import { jsonldPublisherUrl } from './JsonldStore';

export const updateJsonldPublisherUrl = (value) => jsonldPublisherUrl.update((oldValue) => value);
